import { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import loginimg from "../Assets/Images/forget.png";
import logo from "../Assets/Images/Caduceus 512x512.gif";
import { useForm } from "react-hook-form";
import axios from "axios";
import { toast } from "react-toastify";
import OtpInput from "react-otp-input";
import { BASE_URL, checkOpt, OTP } from "../API";
import { activeBorderColor, filledBorderColor, pendingBorderColor } from "../utils/helper";

function Otp() {
  const location = useLocation();
  const [otpCode, setOtpCode] = useState("");
  const [focusedIndex, setFocusedIndex] = useState(null);
  const [email, setEmail] = useState(location?.state?.data);
  const [loading, setLoading] = useState(false);
  const [timer, setTimer] = useState(59);
  const [sendOTP, setSendOTP] = useState(true);
  const renderInput = (props, index) => {
    const isFilled = otpCode[index] !== undefined;
    const isFocused = focusedIndex === index;

    return (
      <input
        {...props}
        onFocus={() => setFocusedIndex(index)}
        onBlur={() => setFocusedIndex(null)}
        className="otp_input_box"
        style={{
          border: `2px solid ${isFocused
            ? activeBorderColor
            : isFilled
              ? filledBorderColor
              : pendingBorderColor
            }`,
          fontSize: "2.4rem",
          color: "#000",
          textAlign: "center",
          outline: "none",
          caretColor: "#000",
          boxSizing: "border-box",
          transition: "border 0.2s ease",
        }}
      />
    );
  };

  const { handleSubmit, formState: { errors } } = useForm();
  const navigate = useNavigate();


  useEffect(() => {
    let timerId;

    if (!sendOTP && timer > 0) { timerId = setInterval(() => { setTimer((prevTimer) => prevTimer - 1); }, 1000); }
    if (timer === 0) { setSendOTP(true) }
    return () => clearInterval(timerId);
  }, [sendOTP, timer]);

  const handleResendClick = async () => {
    if (!sendOTP) return;
    setSendOTP(false);
    setTimer(59);
    try {
      await axios.post(BASE_URL + OTP, { email });
      toast.success("OTP has been resent successfully.");
    } catch (error) {
      console.error(error);
      toast.error("Failed to send OTP.");
    } finally { setLoading(false); }
  }

  const handleOtpSubmit = async (data) => {
    data.language = "ENGLISH";
    setLoading(true);
    try {
      const response = await axios.post(BASE_URL + checkOpt, { email, language: 'ENGLISH', otp: otpCode });
      const user = response.data.data;
      const userToken = user.access_token
      localStorage.setItem('token', userToken)
      toast.success("OTP verified successfully!");
      user.role === 'admin' ? navigate("/dashboard") : navigate("/consultation-logs")
    }
    catch (error) {
      console.error(error);
      toast.error(error?.response?.data?.error_description);
    }
    finally { setLoading(false) }
  };

  return (
    <section className="login-section">
      <div className="container-fluid g-0">
        <Row className="row-min-h">
          <Col lg={6} className="img-n">
            <div className="upper-fig-main-login">
              <figure className="login-img-main">
                <img src={loginimg} alt="" />
              </figure>
            </div>
          </Col>
          <Col lg={6}>
            <div className="inner-login-mian">
              <div className="loginupper-right otp">
                <figure className="creden_page_logo">
                  <img src={logo} alt="" className="img-fluid" />
                </figure>
                <h2>Two Factor authentication</h2>
                <p className="auth_page_sub_heading">
                  Enter the verification code sent to your email to complete
                  2FA. This extra step secures your account.
                </p>
                <Form onSubmit={handleSubmit(handleOtpSubmit)}>
                  <div style={{ display: "flex", justifyContent: "center" }}>
                    <OtpInput
                      value={otpCode}
                      onChange={setOtpCode}
                      numInputs={6}
                      inputType="number"
                      autoFocus
                      renderInput={renderInput}
                      separator={<span style={{ width: "8px" }} />}
                    />
                  </div>
                  {errors.otp && <p>{errors.otp.message}</p>}
                  <div className="auth-bottom-link-sec">
                    <p>
                      Didn't get the code? {
                        sendOTP ?
                          <Link onClick={handleResendClick}>Resend It</Link> :
                          <span style={{ color: "#9B9B9B" }}>
                            Wait {timer} second{timer !== 1 ? 's' : ''} to resend OTP.
                          </span>
                      }</p>
                  </div>
                  <Button className="login-btn" type="submit" disabled={loading}>
                    {loading ? "Verifying..." : "Submit"}
                  </Button>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </section>
  );
}

export default Otp;
